var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5578 18H3.14031C1.49461 18 0.466877 16.3083 1.28972 14.9558L7.94161 4.015C8.76446 2.66167 10.8208 2.66167 11.6428 4.015L15 9.53618L11.2067 15.7754C10.606 16.7639 11.3564 17.9992 12.5586 17.9992L12.5578 18Z",
    fill: "url(#paint0_linear_474_245664)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8647 10.0472L11.1785 16.4296C10.7228 17.219 11.2928 18.2055 12.2042 18.2055H19.5765C20.4879 18.2055 21.0578 17.219 20.6021 16.4296L16.9159 10.0472C16.4602 9.25786 15.3204 9.25786 14.8647 10.0472Z",
    fill: "url(#paint1_linear_474_245664)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 13C9.77614 13 10 12.775 10 12.4975L10 8.5025C10 8.22498 9.77614 8 9.5 8C9.22386 8 9 8.22498 9 8.5025L9 12.4975C9 12.775 9.22386 13 9.5 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.77614 14 10 14.2239 10 14.5C10 14.7761 9.77614 15 9.5 15C9.22386 15 9 14.7761 9 14.5C9 14.2239 9.22386 14 9.5 14Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_474_245664",
    x1: 0.00272568,
    y1: 18.8407,
    x2: 16.7994,
    y2: 15.6493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_474_245664",
    x1: 11.0182,
    y1: 13.8305,
    x2: 20.7624,
    y2: 13.8305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorWarning);
export default __webpack_public_path__ + "static/media/color-warning.ebbf554a068135b3b06a407d8a2ad4a5.svg";
export { ForwardRef as ReactComponent };